export default __webpack_public_path__ + "static/media/7.865b5c81.jpg";